module.exports = __webpack_public_path__ + "img/makerFooter.99143dc5.jpg";